import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    uploadDocument: build.mutation({
      query: (data) => ({
        url: `${apiUrl.postDocument}`,
        method: 'POST',
        body: data
      })
    }),
  }),
  overrideExisting: false,
});
export const {
  useUploadDocumentMutation
} = extendedApi;
